import { bindable } from 'aurelia-framework';
import { BaseButton } from './base-button';

const buttonVariantClasses = {
  primary: 'button--primary',
  secondary: 'button--secondary',
  tertiary: 'button--tertiary',
  ok: 'button--ok',
  warning: 'button--warning',
  danger: 'button--danger',
};

const buttonStyleClasses = {
  filled: 'icon-button--filled',
  outlined: 'icon-button--outlined',
  ghost: 'icon-button--ghost',
  none: 'icon-button',
};

type Variants = keyof typeof buttonVariantClasses;

export class IconButton extends BaseButton {
  @bindable()
  size: 'sm' | 'md' | 'lg' = 'md';

  @bindable()
  variant!: Variants;

  @bindable()
  icon!: string;

  @bindable()
  style: 'filled' | 'outlined' | 'ghost' | 'none' = 'ghost';

  @bindable()
  disabled: boolean = false;

  constructor() {
    super();
  }

  attached() {
    if (!this.variant) {
      this.variant = 'primary';
    }

    if (!this.icon) {
      throw new Error(`[${IconButton.name}] Icon name must be provided, get names from: https://phosphoricons.com/`);
    }

    if (!buttonVariantClasses[this.variant]) {
      throw new Error(
        `[${IconButton.name}] Unknown button variant: ${this.variant}, expected one of: ${Object.keys(buttonVariantClasses).join(', ')}`
      );
    }

    if (!buttonStyleClasses[this.style]) {
      throw new Error(
        `[${IconButton.name}] Unknown button style: ${this.style}, expected one of: ${Object.keys(buttonStyleClasses).join(', ')}`
      );
    }

    this.styleClasses = buttonVariantClasses[this.variant];
    switch (this.size) {
      case 'sm':
        this.styleClasses += ' icon-button--sm';
        break;
      case 'lg':
        this.styleClasses += ' icon-button--lg';
        break;
    }

    this.styleClasses += ` ${buttonStyleClasses[this.style]}`;
  }
}
